import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section
      data-testid="notfound-page"
      className="min-h-[70vh] flex items-center justify-center bg-white py-20 lg:py-28"
    >
      <div className="mp-container text-center">
        <div className="mp-eyebrow-green">Error 404</div>
        <h1 className="mt-3 font-display text-6xl sm:text-7xl lg:text-8xl uppercase leading-[0.9]">
          Page not found.
        </h1>
        <p className="mt-6 max-w-lg mx-auto font-body text-black/65 leading-relaxed text-lg">
          The page you&apos;re looking for doesn&apos;t exist or has moved. Head back to the range.
        </p>
        <div className="mt-10 flex justify-center gap-4 flex-wrap">
          <Link to="/" data-testid="notfound-home" className="mp-btn mp-btn-primary">
            Back to Home
          </Link>
          <Link to="/products" data-testid="notfound-products" className="mp-btn mp-btn-outline">
            Explore Products
          </Link>
        </div>
      </div>
    </section>
  );
}
